import React from 'react';

const AcademiasListar = ({academias}) => {
    return(
        <div className="container">
            <div className="row g-4">
                {academias &&
                    <>
                    {academias?.map((academia) => (
                        <div key={academia.id} className="row academia mb-4 p-3 conteudo-academia">
                                <div className="col-lg-4 image-academia col-md-6 mb10 ">                                      
                                    <center>
                                        <img src={academia.foto} alt={academia.nome} title={academia.razaoSocial} />
                                    </center>
                                </div>
                                <div className="col-lg-6">
                                    <h6>{academia.razaoSocial}</h6>
                                    <p>{academia.logradouro}, {academia.numero} - {academia.cep}</p>
                                    <p>Contato: {academia.contatoCelular} / {academia.contatoTelefone}</p>
                                </div>
                        </div>
                    ))}
                    </>
                }
            </div>
        </div>
    );
}

export default AcademiasListar;